import { render, staticRenderFns } from "./VouchersAdd.vue?vue&type=template&id=ba6eedca"
import script from "./VouchersAdd.vue?vue&type=script&lang=js"
export * from "./VouchersAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports